import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  ADD_DOCUMENT,
  ADD_THE_VERIFICATION_DOCS,
  CHANGE_THE_DOC_STATUS,
  EDIT_DOCUMENT,
  GET_DOCUMENTS_LIST,
  GET_VERIFICATION_DOC_DETAILS,
  SUBMIT_DOC_STATUS,
} from "./actionTypes";

import {
  getRequest,
  postDetailSet,
  putCall,
} from "../../../helpers/fakebackend_helper";
import {
  addDocumentFailed,
  addDocumentSuccess,
  addTheVerificationDocsFailed,
  addTheVerificationDocsSuccess,
  changeTheDocStatusFailed,
  changeTheDocStatusSuccess,
  editDocumentFailed,
  editDocumentSuccess,
  getDocumentsListFailed,
  getDocumentsListSuccess,
  getVerificationDocDetailsFailed,
  getVerificationDocDetailsSuccess,
  submitDocStatusFailed,
  submitDocStatusSuccess,
} from "./actions";
//restapi end point
//import * as constClass from "../../../../common/constant/constantURL";
import * as constClass from "../../../common/constant/constantURL";
// get candidate list

function* getDocumentsListHandler(data) {
  try {
    let obj = data.payload;

    var url =
      constClass.REST_API_DOCUMENTS +
      "?pageNumber=" +
      obj.pageNumber +
      "&pageSize=" +
      obj.pageSize;
    if (obj.active !== undefined && obj.active !== null && obj.active !== "") {
      url = url + "&active=" + obj.active;
    }
    if (
      obj.searchKeyword !== null &&
      obj.searchKeyword !== undefined &&
      obj.searchKeyword !== ""
    ) {
      url = url + "&keyword=" + obj.searchKeyword;
    }
    var responsJSON = yield call(getRequest, url);
    yield put(getDocumentsListSuccess(responsJSON));
  } catch (error) {
    yield put(getDocumentsListFailed(error));
  }
}

function* addDocumentHandler(data) {
  try {
    let obj = data.payload;

    var url = constClass.REST_API_DOCUMENTS;
    var responsJSON = yield call(postDetailSet, url, obj);
    yield put(addDocumentSuccess(responsJSON));
  } catch (error) {
    yield put(addDocumentFailed(error));
  }
}

function* editDocumentHandler(data) {
  try {
    let obj = data.payload;
    var url = constClass.REST_API_DOCUMENTS;
    var responsJSON = yield call(putCall, url, obj);
    yield put(editDocumentSuccess(responsJSON));
  } catch (error) {
    yield put(editDocumentFailed(error));
  }
}

function* changeTheDocStatusHandler(data) {
  try {
    let id = data.payload;

    var url = constClass.REST_API_DOCUMENTS + "/status?id=" + id;

    var responsJSON = yield call(getRequest, url);
    yield put(changeTheDocStatusSuccess(responsJSON));
  } catch (error) {
    yield put(changeTheDocStatusFailed(error));
  }
}

function* addVerificationHandler(data) {
  try {
    console.log("🔥 Saga: addVerificationHandler triggered!");
    console.log("📦 Saga: Payload received:", data.payload);

    let obj = data.payload;
    var url = constClass.REST_API_VERIFY_DOCUMENTS;

    console.log("🌐 Saga: API URL:", url);
    console.log("📤 Saga: Making POST request with data:", obj);

    var responsJSON = yield call(postDetailSet, url, obj);

    console.log("✅ Saga: Response received:", responsJSON);

    yield put(addTheVerificationDocsSuccess(responsJSON));
  } catch (error) {
    console.error("❌ Saga: Error occurred:", error);
    yield put(addTheVerificationDocsFailed(error));
  }
}

function* getVerificationDocHandler(data) {
  try {
    let obj = data.payload;

    var url =
      constClass.REST_API_VERIFY_DOCUMENTS +
      `?jobId=${obj.jobId}&candidateId=${obj.candidateId}`;
    var responsJSON = yield call(getRequest, url);
    yield put(getVerificationDocDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getVerificationDocDetailsFailed(error));
  }
}

function* submitDocStatusHandler(data) {
  try {
    console.log("🔥 Saga: submitDocStatusHandler triggered!");
    console.log("📦 Saga: Payload received:", data.payload);

    let obj = data.payload;

    var url = constClass.REST_API_VERIFY_DOCUMENTS;

    console.log("🌐 Saga: API URL:", url);
    console.log("📤 Saga: Making PUT request with data:", obj);

    var responsJSON = yield call(putCall, url, obj);

    console.log("✅ Saga: Response received:", responsJSON);

    yield put(submitDocStatusSuccess(responsJSON));
  } catch (error) {
    console.error("❌ Saga: Error occurred:", error);
    console.error("❌ Saga: Error details:", error.response || error.message);
    yield put(submitDocStatusFailed(error));
  }
}

export function* documentsHandler() {
  yield takeEvery(GET_DOCUMENTS_LIST, getDocumentsListHandler);
  yield takeEvery(ADD_DOCUMENT, addDocumentHandler);
  yield takeEvery(EDIT_DOCUMENT, editDocumentHandler);
  yield takeEvery(CHANGE_THE_DOC_STATUS, changeTheDocStatusHandler);
  yield takeEvery(ADD_THE_VERIFICATION_DOCS, addVerificationHandler);
  yield takeEvery(GET_VERIFICATION_DOC_DETAILS, getVerificationDocHandler);
  yield takeEvery(SUBMIT_DOC_STATUS, submitDocStatusHandler);
}

function* documentsSaga() {
  yield all([fork(documentsHandler)]);
}

export default documentsSaga;
